package top.wcpe.allincore.dsl.compiler.source

/**
 * 源码范围，偏移使用 Kotlin 字符串的 UTF-16 code unit，区间为左闭右开。
 */
data class SourceRange(
    val sourceId: String,
    val start: Int,
    val end: Int,
) {
    init {
        val noPosition = sourceId.isEmpty() && start == -1 && end == -1
        require(noPosition || (sourceId.isNotEmpty() && start >= 0 && end >= start)) {
            "源码范围必须合法，或使用唯一无位置范围"
        }
    }

    val length: Int
        get() = if (this == NONE) 0 else end - start

    fun merge(other: SourceRange): SourceRange {
        if (this == NONE) return other
        if (other == NONE) return this
        require(sourceId == other.sourceId) { "不能合并不同 sourceId 的源码范围" }
        return SourceRange(sourceId, minOf(start, other.start), maxOf(end, other.end))
    }

    companion object {
        /** 完全由编译器合成且没有原始语法来源时使用的唯一范围。 */
        val NONE = SourceRange("", -1, -1)
    }
}
